<template>
  <div>
    <v-dialog v-model="dialog" persistent width="700px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            お知らせ登録
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-container>
            <v-row class="mx-2">
              <v-col cols="12" class="text-right mt-n5">
                <span class="error--text">* </span>
                <span>は必須項目</span>
              </v-col>
            </v-row>
            <v-row class="mx-2">
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-text-field v-model="form.title" id="title" :rules="rules.titleRules" maxlength="20" required>
                  <template v-slot:label>
                    <span>タイトル</span>
                    <span class="error--text"> *</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-textarea
                  v-model="form.message"
                  id="message"
                  :rules="rules.messageRules"
                  :counter="1000"
                  required
                >
                  <template v-slot:label>
                    <span>内容</span>
                    <span class="error--text"> *</span>
                  </template>
                </v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-date label="表示開始日" v-model="form.validPeriodFrom" required> </v-date>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-date label="表示終了日" v-model="form.validPeriodTo" required> </v-date>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions class="gray">
            <v-spacer />
            <v-btn v-if="updateFlag" color="error" class="px-4" elevation="2" @click="deleteMessage">削除</v-btn>
            <v-btn color="primary" class="px-4" elevation="2" @click="save">登録</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "MessageEdit",
  data: () => ({
    dialog: false,
    valid: true,
    updateFlag: false,
    form: {
      messageNo: "",
      title: "",
      message: "",
      validPeriodFrom: "",
      validPeriodTo: "",
      register: "",
      registerDate: null,
      updater: "",
      updateDate: null,
      version: 1,
      deleteFlag: false
    },
    rules: {}
  }),
  computed: {
    ...mapState(["user"])
  },
  created() {
    this.setRules();
  },
  methods: {
    setRules() {
      this.rules = {
        titleRules: [this.$getValidate("required", "タイトル")],
        messageRules: [this.$getValidate("required", "内容"), this.$getValidate("maxlength", "内容", 1000)],
        validPeriodFromRules: [this.$getValidate("required", "表示開始日")],
        validPeriodToRules: [this.$getValidate("required", "表示終了日")]
      };
    },
    async open(item) {
      if (this.$refs.form) {
        this.$refs.form.reset();
        this.form = this.$options.data().form;
      }
      if (item == null) {
        this.form.title = "";
        this.form.messageNo = "";
        this.form.message = "";
        this.form.validPeriodFrom = "";
        this.form.validPeriodTo = "";
        this.form.register = "";
        this.form.registerDate = null;
        this.form.updater = "";
        this.form.updateDate = null;
        this.form.version = 1;
        this.form.deleteFlag = false;
        this.updateFlag = false;
        this.dialog = true;
      } else {
        const message = await this.$api.getMessage(item);
        this.form.messageNo = message.messageNo;
        this.form.title = message.title;
        this.form.message = message.message;
        this.form.validPeriodFrom = message.validPeriodFrom;
        this.form.validPeriodTo = message.validPeriodTo;
        this.form.register = message.register;
        this.form.registerDate = message.registerDate;
        this.form.updater = message.updater;
        this.form.updateDate = message.updateDate;
        this.form.version = message.version;
        this.form.deleteFlag = message.deleteFlag;
        this.updateFlag = true;
        this.dialog = true;
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        window.openLoading();
        let data = null;
        if (this.form.messageNo) {
          data = await this.$api.updateMessage(this.form);
        } else {
          data = await this.$api.addMessage(this.form);
        }
        window.closeLoading();
        if (data && data.status == 200) {
          this.$emit("messageEdited");
          this.dialog = false;
        }
      }
    },
    async deleteMessage() {
      window.openLoading();
      const data = await this.$api.deleteMessage(this.form);
      window.closeLoading();
      if (data && data.status == 200) {
        this.$emit("messageEdited");
        this.dialog = false;
      }
    }
  }
};
</script>
